export default __webpack_public_path__ + "static/media/INFX.63f69b00.svg";